import React, { useEffect, useState } from 'react'
import BarGraph from './BarGraph'
import dayjs from 'dayjs'

const DailyActiveUsers = ({ data, endDate, onDateSelect, selectedDate }) => {
  const [groupData, updatedGroupedData] = useState([])

  useEffect(() => {
    const groupedData = {}
    const endTime = dayjs(endDate).format('HH:mm:ss')
    const [hour, minute, second] = endTime.split(':').map(Number)
    if (data && data.length != 0) {
      data.forEach((record) => {
        const logDate = dayjs(record.loggedAt)
        const logDateKey = logDate.format('MM/DD')
        if (!groupedData[logDateKey]) {
          groupedData[logDateKey] = 1
        } else {
          groupedData[logDateKey] += 1
        }
      })
      const mappedData = Object.keys(groupedData).map((key) => {
        const formattedDate = key
        // If Count is 0, set to 0.1 for chart visibility
        return {
          Count: groupedData[key],
          Dates: formattedDate,
        }
      })
      updatedGroupedData(mappedData)
    }
  }, [data])

  return (
    <BarGraph
      data={groupData}
      xField={'Dates'}
      yField={'Count'}
      onBarClick={onDateSelect}
    />
  )
}

export default DailyActiveUsers
